import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Memo, MemoShortName } from '../models/memo.model';
import { ApiRoutes } from '../../shared/constants/routes';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MemoService {
  private readonly http = inject(HttpClient);

  public getMemoByShortName(shortName: string | MemoShortName): Observable<Memo> {
    return this.http.get<Memo>(ApiRoutes.memo.byShortName(shortName));
  }

  public upsertMemo(shortName: string | MemoShortName, content: string): Observable<Memo> {
    return this.http.put<Memo>(ApiRoutes.memo.byShortName(shortName), { content });
  }
}
